import React from 'react';
import ContentContainer from '../ContentContainer/ContentContainer';
import PFSContactCta from '../PFSContactCta/PFSContactCta';
import PFSServiceHeader from '../PFSServiceHeader/PFSServiceHeader';
import PFSServicePoints from '../PFSServicePoints/PFSServicePoints';
import PFSWhyChoosePFS from '../PFSWhyChoosePFS/PFSWhyChoosePFS';
import styles from './PFSWhatWeDoLegal.module.css';
import globalStyles from '../../styles/global.module.css';
import PFSMeetTheTeam from '../PFSMeetTheTeam/PFSMeetTheTeam';

import legalImage from './legal.jpg'
import { useBreadcrumb } from '../../hooks/useBreadcrumb';
import { WhatWeDoBreadcrumb } from '../PFSWhatWeDoIndex/PFSWhatWeDoIndex';
import { useLocation } from 'react-router-dom';
 
const PFSWhatWeDoLegal = () => {
  const { pathname } = useLocation();

  useBreadcrumb([
    WhatWeDoBreadcrumb,
    {
      label: 'Legal Operations',
      url: pathname,
    },
  ]);  
  return(
  <div className={styles.PFSWhatWeDoLegal} data-testid='PFSWhatWeDoLegal'>
    <ContentContainer>
      <PFSServiceHeader subtitle='Legal Operations' title='Solving for the Modern Nonprofit.' />
            <div className={globalStyles.IntroContainer}>
              <img src={legalImage} alt='' className={globalStyles.IntroImage} />
              <div className={globalStyles.IntroText}>
                <p>At PFS Global, we offer comprehensive legal services tailored to the unique needs of non-profit organizations, their boards, and executive leadership. We take a client-centric approach to deliver customized solutions, from governance and bylaws structure to contract management, that meet your specific operational requirements.</p>
                <p>Our commitment to excellence and our dedication to your success ensures that we achieve your legal and regulatory objectives, providing peace of mind and safeguarding your organization's assets. Contact us today to learn how we can assist you.</p>
              </div>
            </div>
            <PFSServicePoints
              title='Organizational and Mission Transactions'
              points={[
                'Mergers, Acquisitions, and Asset Transfers (Combining Non-Profits or Absorbing Programs)',
                'Document Drafting: Corporate Bylaws, Conflict of Interest Policies, and Board Policies',
                'Tax-Exempt Entity Formations (State Incorporation and IRS 1023/1024 Filings)',
              ]}
            />
            <PFSServicePoints
              title='Board and Regulatory Compliance'
              points={[
                'Agent for Service of Process in each state',
                'Annual Secretary of State Filings in each state',
                {
                  label: 'Annual meeting with attorney to review and update:',
                  subpoints: ["Board Meeting Minutes and Resolutions", "Bylaws and Governance Policy Updates"]
                },
                'Annual Beneficial Ownership Information Reporting',
              ]}
            />
    </ContentContainer>
    <PFSWhyChoosePFS />
    <PFSMeetTheTeam department='Legal' />
    <br />
    <br />
    <br />
    <br />
    <br />
    <PFSContactCta ctaText='Call us today!' />
  </div>
)};

PFSWhatWeDoLegal.propTypes = {};

export default PFSWhatWeDoLegal;
